// Product Tilt Constants
export const TILT_ANGLES = {
  SMALL: 8,
  MEDIUM: 12,
  LARGE: 16
} as const

export const TILT_STRATEGIES = {
  SINGLE_PRODUCT: {
    LEFT: 'single_left',
    RIGHT: 'single_right'
  },
  DUAL_PRODUCT: {
    BOTH_SAME: 'both_same',
    LEFT_ONLY: 'left_only',
    RIGHT_ONLY: 'right_only',
    OPPOSITE: 'opposite'
  },
  TRIPLE_PRODUCT: {
    ALL_SAME: 'all_same',
    FAN_LEFT: 'fan_left',
    SIDE_TILT: 'side_tilt'
  }
} as const

export type TiltStrategy =
  | typeof TILT_STRATEGIES.SINGLE_PRODUCT[keyof typeof TILT_STRATEGIES.SINGLE_PRODUCT]
  | typeof TILT_STRATEGIES.DUAL_PRODUCT[keyof typeof TILT_STRATEGIES.DUAL_PRODUCT]
  | typeof TILT_STRATEGIES.TRIPLE_PRODUCT[keyof typeof TILT_STRATEGIES.TRIPLE_PRODUCT]
